module.exports = require("./dist/abn_tree_directive.js");
require("./dist/abn_tree.css");


//////////////////
// WEBPACK FOOTER
// angular-bootstrap-nav-tree (bower component)
// module id = 1014
// module chunks = 1